import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownItem, DropdownMenu } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import config from '@plone/volto/registry';

const HeaderSlimListItemUniba = ({
    staticLink = true,
    endpoint = "",
    dropdown_json = {},
    href,
    title,
    ...attributes
}) => {
    const [dropdownContent, setDropdownContent] = useState("");
    const lang = useSelector((state) => state.intl.locale);
    const intl = useIntl();
    const intl_menuItems = intl.formatMessage({ id: 'menuItems' }, { title: title });

    useEffect(() => {
        if (!staticLink && endpoint) {
            // Effettua la richiesta quando staticLink è false
            let fullEndpoint;
            if (config.settings.isMultilingual) {
                fullEndpoint = `${window.location.origin}/++api++/${lang}${endpoint}`;
            } else {
                fullEndpoint = `${window.location.origin}/++api++${endpoint}`;
            }
            fetch(fullEndpoint)
                .then(response => response.text()) // Ottieni il contenuto come testo
                .then(html => {
                    setDropdownContent(html); // Aggiorna lo stato con il contenuto HTML
                })
                .catch(error => console.error("Error fetching the content:", error));
        }
    }, [staticLink, endpoint]); // Dipendenze: esegue l'effetto solo quando staticLink o endpoint cambiano


    return (
        <li role="none">
            {staticLink ? (
                // Caso 1: Static link
                <a
                    href={href}
                    aria-label={title}
                    title={title}
                    role="menuitem"
                    {...attributes}
                >
                    {title}
                </a>
            ) : endpoint ? (
                // Caso 2: Dynamic dropdown con endpoint
                <Dropdown
                    text={title}
                    aria-label={`Menu ${title}`}
                    role="menuitem"
                    aria-haspopup="true"
                    tabIndex={0}
                    {...attributes}
                >
                    <DropdownMenu
                        role="menu"
                        aria-label={intl_menuItems}
                    >
                        {dropdownContent ? (
                            <DropdownItem role="menuitem">
                                <div dangerouslySetInnerHTML={{ __html: dropdownContent }} />
                            </DropdownItem>
                        ) : (
                            <DropdownItem role="menuitem">
                                <span>Loading...</span>
                            </DropdownItem>
                        )}
                    </DropdownMenu>
                </Dropdown>
            ) : (
                // Caso 3: Dropdown basato su `dropdown_json`
                <Dropdown
                    text={title}
                    aria-label={`Menu ${title}`}
                    role="menuitem"
                    aria-haspopup="true"
                    tabIndex={0}
                    {...attributes}
                >
                    <DropdownMenu
                        role="menu"
                        aria-label={intl_menuItems}
                    >
                        {Object.keys(dropdown_json).map((key) => (
                            <DropdownItem key={key} role="menuitem">
                                <a
                                    href={dropdown_json[key]}
                                    aria-label={key}
                                    title={key}
                                    role="menuitem"
                                >
                                    {key}
                                </a>
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                </Dropdown>
            )}
        </li>
    );
};

export default HeaderSlimListItemUniba;